/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SignalDataSelection } from './signalDataSelection';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { EnforcementTypeSelection } from './enforcementTypeSelection';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';
import { EnforcementStateEnum } from './enforcementStateEnum';
import { EnforcementSignalStatusEnum } from './enforcementSignalStatusEnum';


export interface EnforcementSignalPatchSpec { 
    org_id?: string;
    service_type?: ServiceTypeEnum;
    vcds_service_type?: VcdsServiceTypeEnum;
    enforcement_type?: EnforcementTypeSelection;
    signal_data?: Array<SignalDataSelection>;
    state?: EnforcementStateEnum;
    status?: EnforcementSignalStatusEnum;
    state_entered_ts?: Date;
    next_action_ts?: Date;
    id?: number;
}
export namespace EnforcementSignalPatchSpec {
}


